// src/ui/theme/tokens.js
// Tokens de marca Educa360 — FUENTE UNICA DE VERDAD del design system.
// Documentados en design-system/STYLE_GUIDE.md.
//
// Aplicacion INCREMENTAL: el theme global (educaTheme.js, azul legacy) NO se
// toca. Las pantallas migradas se envuelven con `educaBrandTheme` via
// <ConfigProvider theme={educaBrandTheme}>.

export const brand = {
  green: "#00A75A", // PRIMARY
  greenDark: "#1C7A39",
  greenBright: "#16A934",
  yellow: "#FFD400", // ACENTO
  yellowDeep: "#F9B016",
};

export const semantic = {
  draft: "#8C8C8C",
  active: "#00A75A",
  archived: "#D9A100",
  danger: "#FF4D4F",
  info: "#1677FF",
};

export const neutral = {
  sidebar: "#0E0E12",
  canvas: "#F5F6FB",
  card: "#FFFFFF",
  text: "#1F2430",
  textMuted: "#6B7280",
  border: "#E5E7EB",
};

export const radius = { control: 12, card: 16, pill: 999 };

export const shadow = {
  card: "0 4px 16px rgba(16,24,40,.06)",
  hover: "0 8px 24px rgba(16,24,40,.10)",
};

export const font = {
  display: "'Nunito', sans-serif",
  body: "'Roboto', sans-serif",
};

// Theme Ant Design de marca. Se aplica por pantalla (no global) hasta que
// toda la plataforma este migrada (ver design-system/ROADMAP.md).
export const educaBrandTheme = {
  token: {
    colorPrimary: brand.green,
    colorInfo: brand.green,
    colorSuccess: brand.green,
    colorError: semantic.danger,
    colorText: neutral.text,
    colorTextSecondary: neutral.textMuted,
    colorBorderSecondary: neutral.border,
    colorBgLayout: neutral.canvas,
    borderRadius: radius.control,
    fontFamily: font.body,
  },
  components: {
    Button: {
      borderRadius: radius.control,
      controlHeight: 40,
      fontWeight: 600,
    },
    Card: { borderRadiusLG: radius.card, boxShadowTertiary: shadow.card },
    Table: { headerBg: "transparent", borderRadius: radius.card },
    Tag: { borderRadiusSM: radius.pill },
    Menu: {
      // Sidebar oscuro Educa360 (charcoal + item activo = pill verde con glow)
      darkItemBg: neutral.sidebar,
      darkPopupBg: neutral.sidebar,
      darkItemColor: "rgba(255,255,255,.70)",
      darkItemHoverBg: "rgba(0,167,90,.12)", // hover en familia verde (homogeneo con el activo)
      darkItemHoverColor: "#ffffff",
      darkItemSelectedBg: "rgba(0,167,90,.18)", // translucido (el borde+glow lo pone el SCSS)
      darkItemSelectedColor: "#ffffff",
      itemBorderRadius: 12,
      itemMarginInline: 12,
      itemMarginBlock: 6,
      itemHeight: 46,
      iconSize: 18,
    },
    Modal: { borderRadiusLG: radius.card },
    Input: { borderRadius: radius.control, controlHeight: 40 },
    Select: { borderRadius: radius.control, controlHeight: 40 },
  },
};

const tokens = {
  brand,
  semantic,
  neutral,
  radius,
  shadow,
  font,
  educaBrandTheme,
};

export default tokens;
